import React from 'react';
import { useState, useEffect } from 'react'
import Alert from '@material-ui/lab/Alert';
import Box from "@material-ui/core/Box";
import { makeStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme) => ({
    alertBox:{
        display:"block",
        position:"fixed",
        top:"5%",
        left:"calc(50% - 150px)",
        width:"300px",
        zIndex:"100"
    }
}));
const Message = ({ severity, text, }) => {
  const [show, setShow] = useState(true)
  const cssStyle=useStyles()
  useEffect(() => {
    const timeId = setTimeout(() => {
      setShow(false)
    }, 4000)

    return () => {
      clearTimeout(timeId)
    }
  }, []);

  if (!show) {
    return null;
  }

  return (
    <Box className={cssStyle.alertBox}>
        <Alert onClose={() =>  setShow(null)} severity={!severity?"error":"success"}>{text}</Alert>
    </Box>)
}

Message.defaultPros = {
  variant: 'info',
}

export default Message;